var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { logger } from "../../log.mjs";
import { createRandomId } from "../../utils.mjs";
import { initializeStripePaymentElements } from "./paymentElements.mjs";
import { initializeStripeExpressElements } from "./expressElements.mjs";
import { initializeStripeBillingAddressElements } from "./billingAddressElements.mjs";
import { initializeStripeShippingAddressElements } from "./shippingAddressElements.mjs";
import { loadStripeIfNeeded } from "./utils.mjs";
export const expressCheckoutElementId = 'stripe-express-checkout-container';
export const shippingAddressElementId = 'stripe-shipping-address-container';
export const billingAddressElementId = 'stripe-billing-address-container';
export const paymentElementId = 'stripe-payment-container';
let elements;
export const initializeStripeElements = (state, actions, cartCheckout, cartPayment) => __awaiter(void 0, void 0, void 0, function* () {
    const stripe = yield loadStripeIfNeeded(cartPayment);
    const options = getStripeElementsOptions(state, cartCheckout, cartPayment);
    const { elements, status } = getOrCreateStripeElements(stripe, options);
    if (status === 'reused') {
        const { error } = yield elements.fetchUpdates();
        if (error) {
            logger.error({ error }, 'Failed to fetch updates for Stripe elements');
        }
    }
    initializeStripeExpressElements(state, actions, cartPayment, cartCheckout);
    initializeStripeShippingAddressElements(state, actions, elements);
    initializeStripeBillingAddressElements(state, actions, elements);
    initializeStripePaymentElements(state, actions, cartPayment, elements);
});
export const paymentIntentClientSecret = (state) => {
    validateStripeCheckoutPayment(state);
    return state.checkout.payment.elements.paymentIntentClientSecret;
};
const getOrCreateStripeElements = (stripe, options) => {
    const incomingClientSecret = options.clientSecret;
    if (!elements || elements.clientSecret !== incomingClientSecret) {
        elements = Object.assign({ id: createRandomId(), clientSecret: incomingClientSecret }, stripe.elements(options));
        return { status: 'created', elements };
    }
    return { status: 'reused', elements };
};
const getStripeElementsOptions = (state, cartCheckout, cartPayment) => {
    var _a, _b;
    // We explicitly pick properties from paymentProviderElementsOptions instead of
    // spreading the object because it is exposed in the SDK. This ensures we only use known
    // properties and prevents other options from being passed to Stripe Elements,
    // which could cause unexpected behavior or conflicts with our internal configuration.
    const { appearance, fonts, loader, locale } = (_b = (_a = state.paymentProviderElementsOptions.stripe) === null || _a === void 0 ? void 0 : _a.elements) !== null && _b !== void 0 ? _b : {};
    return {
        clientSecret: cartPayment.elements.paymentIntentClientSecret,
        appearance,
        fonts,
        loader,
        locale,
        syncAddressCheckbox: 'none',
        customPaymentMethods: cartCheckout.showInvoicePaymentOption ? [{ id: 'cpmt_1S8gpfGklE6B0bhsP58oClpK', options: { type: 'static' } }] : undefined,
    };
};
function validateStripeCheckoutPayment(state) {
    var _a, _b;
    if (((_b = (_a = state.checkout) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.$type) !== 'stripeCheckout') {
        state.onUnexpectedError('Invalid payment type');
        throw new Error('Invalid payment type');
    }
}
//# sourceMappingURL=elements.js.map